import { render } from "./ToolTip.vue?vue&type=template&id=64c8fee5&ts=true"
import script from "./ToolTip.vue?vue&type=script&lang=ts"
export * from "./ToolTip.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__